var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.28528,
    y: 8.58923,
    width: 12.7835,
    height: 8.81344,
    rx: 4.40672,
    fill: "#A6E4FF",
    stroke: "#A6E4FF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3549 12.996C12.3549 14.4833 11.1492 15.689 9.66187 15.689C8.17457 15.689 6.96887 14.4833 6.96887 12.996C6.96887 11.5087 8.17457 10.303 9.66187 10.303C11.1492 10.303 12.3549 11.5087 12.3549 12.996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0688 12.996C14.0688 15.4297 12.0959 17.4027 9.66209 17.4027C7.22833 17.4027 5.25537 15.4297 5.25537 12.996C5.25537 10.5622 7.22833 8.58923 9.66209 8.58923C12.0959 8.58923 14.0688 10.5622 14.0688 12.996ZM9.66209 15.689C11.1494 15.689 12.3551 14.4833 12.3551 12.996C12.3551 11.5087 11.1494 10.303 9.66209 10.303C8.17479 10.303 6.9691 11.5087 6.9691 12.996C6.9691 14.4833 8.17479 15.689 9.66209 15.689Z",
    fill: "#26B0EB",
    stroke: "#26B0EB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.506 9.6544C20.8142 8.95328 19.8513 8.58923 18.7255 8.58923C17.5998 8.58923 16.6368 8.95328 15.9451 9.6544C15.2805 10.3286 14.9143 11.2858 14.9143 12.351V17.1645H16.8538V12.351C16.8538 11.2724 17.654 10.4499 18.7255 10.4499C19.797 10.4499 20.5972 11.2724 20.5972 12.351V17.1645H22.5367V12.351C22.5367 11.2858 22.1705 10.3286 21.506 9.6544Z",
    fill: "#26B0EB",
    stroke: "#26B0EB",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEv);
export default __webpack_public_path__ + "static/media/ev.0e8831ee3d97773b142b250c66a14af6.svg";
export { ForwardRef as ReactComponent };